import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { countries } from "../constants/countries";
import { POST } from "../constants/request-type";
import { create_geographical, geographical } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import { uploadFile } from "../functions/upload-file";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Geographical_new extends Component {
  state = {
    visible: false,
    name: "",
    eng_name: "",
    country_name: "",
    icon: null,
    locked: false,
    load: false
  };

  componentDidMount() {}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    e.preventDefault();
    return this.setState({ icon: e.target.files[0] });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });
    const { name, eng_name, country_name, icon } = this.state;

    const data = {
      name: name.toLowerCase(),
      eng_name: eng_name.toLowerCase(),
      country_name: country_name.toLowerCase()
    };

   

    if (icon === null) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", "Veuillez upload l'icon");
    }

    const icon_url = await uploadFile(icon);

    if (!icon_url.data.success) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de l'envoie de l'image, veuillez ressayer"
      );
    }

   

    const request_details = {
      type: POST,
      url: service_api,
      route: geographical + "/" + create_geographical,
      data: {
        ...data,
        icon: icon_url.data.url
      },
      token: token
    };

    if (data.name.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { name, eng_name, country_name, icon, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined /> Ajouter
        </Button>
        <Drawer
          title="Ajouter une situation géographique"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      title: "allergie"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="nom"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="eng_name"
                  label="Nom anglais"
                  rules={[
                    {
                      required: true,
                      title: "geographical"
                    }
                  ]}
                >
                  <Input
                    name="eng_name"
                    placeholder="nom anglais"
                    onChange={this.handleChange}
                    value={eng_name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="country_name"
                  label="Pays affilié"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez selectionner un pays"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Pays"
                    defaultValue={country_name}
                    showSearch
                    onChange={(data) => {
                      return this.setState({ country_name: data });
                    }}
                  >
                    {countries?.map((item) => (
                      <Option key={item?.name?.toLowerCase()}>
                        <span>
                          <img
                            alt="img-pays"
                            src={item.file_url}
                            style={{
                              width: 20,
                              height: 20,
                              objectFit: "contain"
                            }}
                          />{" "}
                          {item?.name}
                        </span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Icon"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImageChange}
                    value={icon}
                    name="icon"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Geographical_new;
